<script setup lang="ts">
</script>

<template>
  <h1 class="hd-title">Customer Management</h1>
  <router-view></router-view>
</template>

<style scoped>

</style>